module.exports = __webpack_public_path__ + "img/system_bj.49743534.png";